<template>
  <div id="login" class="container-24">
    <loading
      :show="showSpinner"
      label="Loading..."
      :overlay="true">
    </loading>

    <div class="container login-container">
      <div class="row login-section">
        <section class="col-sm-12 login-desc-header">
          <h1 class="title-24">Sign In</h1>
            <div class="card-text-container col-sm-12 login-desc-text">
              <div class="text-24">
                <p>
                  Manage your membership online. Edit your profile, make payments, see your club visits and Fit:Perks&reg; rewards,
                  and add services like personal training.
                </p>
              </div>
            </div>
        </section>
      </div>
      <div class="row error-message-section" v-if="loginErrorMessage.length > 0">
        <section class="col-sm-12 alert alert-danger" role="alert" >
          <div>
            <a class="close marright10" aria-label="close" title="close" v-on:click="loginErrorMessage = ''" >
              ×
            </a>
            <span class="marleft10">{{ loginErrorMessage }}</span>
          </div>
        </section>
      </div>
    </div>

    <div class="container login-container">
      <form @submit.prevent="validateAndSubmitForm">
        <div class="row login-section login-end-page">
            <!-- Login Image -->
            <section class="card-24 col-md-12 login-info-section">
              <div class="card-img-container left-side col-md-6">
                <img src="../assets/login-image.jpg" class="full-img" alt="Member Sign In">
              </div>
              <!-- Login Username -->
              <div class="col-md-6">
                <div class="row">
                  <div class="materialized col-xs-12">
                    <div class="materialized form-group">
                      <input type="text" class="form-control form-control-warning" id="login-info-usrname"
                             name="login-info-usrname" :class="{'input': true, 'is-danger': errors.has('login-info-usrname')}"
                             placeholder="Username or Check-In Code" v-model="loginInfo.usrname" v-validate="'required'">
                      <label for="login-info-usrname">Username or Check-In Code</label>
                      <span v-show="errors.has('login-info-usrname')"
                            class="help is-danger">{{ errors.first('login-info-usrname') }}</span>
                    </div>
                  </div>
                </div>
                <!-- Login Password -->
                <div class="row">
                  <div class="materialized col-xs-12">
                    <div class="form-group materialized">
                      <input type="password" class="form-control form-control-warning" id="login-info-passwrd"
                             name="loginPasswrd" ref="loginPasswrd" :class="{'input': true, 'is-danger': errors.has('loginPasswrd')}"
                             placeholder="Password" v-model="loginInfo.passwrd" v-validate="'required'">
                      <label for="login-info-passwrd">Password</label>
                      <span class="input-group-btn btn btn-view pull-right">
                        <button type="button" class="btn btn-link"
                                v-on:click="togglePassword()">
                          <i class="fa fa-eye" ref="eyeIcon" aria-hidden="true"></i>
                        </button>
                      </span>
                      <span v-show="errors.has('loginPasswrd')"
                            class="help is-danger">{{ errors.first('loginPasswrd') }}</span>
                    </div>
                  </div>
              </div>
                <div class="row">
                  <!-- Remember Me Checkbox -->
                  <div class="materialized col-xs-6">
                    <div class="materialized form-group">
                      <el-checkbox role="button" id="remember_me" label="Remember Me" v-model="loginInfo.rememberMe"></el-checkbox>
                    </div>
                  </div>
                  <!-- Forgot credential link -->
                  <div class="materialized col-xs-6">
                    <div class="forgot-password-link form-group">
                      <a v-bind:href="forgotCredentialsUrl" v-on:click="redirectToForgotCredentials()" >
                        <label class="labelPointer"><u>I forgot my username/password</u></label>
                      </a>
                    </div>
                  </div>
              </div>

                <!-- Login and register buttons -->
                <div class="row martop20">
                  <div class="materialized col-xs-12">
                    <div class="create-account-link form-group">
                      <a v-bind:href="registrationUrl" v-on:click="redirectToRegistration()" >
                        <label class="labelPointer" ><u>Create New Account</u></label>
                      </a>
                    </div>
                    <div class="form-group">
                      <button id="login-btn" class="btn btn-primary btn-block pull-right" type="submit">Login</button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
  import loading from '@/components/Loading.vue'
  import { loginService, authService } from '../services/ServiceContainer'
  import cfg from '../services/configuration/PropertiesConfiguration'

  export default {
    props: ['redirect_uri'],
    name: 'login',
    components: {
      'loading': loading
    },
    data () {
      return {
        showSpinner: false,
        loginInfo: {
          usrname: '',
          passwrd: ''
        },
        redirectURI: '',
        rememberMe: false,
        errorCode: '',
        errorMessage: '',
        loginErrorMessage: '',
        forgotCredentialsUrl: '',
        registrationUrl: ''
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.redirectURI = vm.$route.query.redirect_uri
        if (authService.isLoggedIn()) {
          let redirectURL = vm.redirectURI
          if (redirectURL !== undefined) {
            window.location.href = redirectURL
          } else {
            window.location.href = cfg.defaultURI
          }
        } else {
        }
      })
    },
    mounted () {
      this.loginInfo.usrname = loginService.getSavedUsername()
      this.forgotCredentialsUrl = cfg.forgotCredentialsUrl
      this.registrationUrl = cfg.registrationUrl
      this.redirectURI = this.redirect_uri
    },
    methods: {
      togglePassword () {
        let newType = this.$refs['loginPasswrd'].getAttribute('type') === 'password' ? 'text' : 'password'
        this.$refs['loginPasswrd'].setAttribute('type', newType)
        this.$refs['loginPasswrd'].focus()
      },
      validateAndSubmitForm () {
        this.$validator.validateAll().then((result) => {
          //  if the result is true(no validation errors) then do the login
          if (result) {
            this.performLogin()
            return
          }
        })
      },
      /** Method is used to login and set the token/error message
       * @param username
       * @param password
       */
      performLogin () {
        return new Promise((resolve, reject) => {
          this.showSpinner = true
          loginService.login({
            username: this.loginInfo.usrname,
            password: this.loginInfo.passwrd
          }).then((response) => {
            this.showSpinner = false
            this.setData(response.data)
            //  if rememberMe is checked then save the username in cookie
            if (this.loginInfo.rememberMe) {
              this.saveUsername(this.loginInfo.usrname)
            }
            //  redirect uri or default page
            if (this.redirectURI !== undefined) {
              window.location.href = this.redirectURI
            } else {
              window.location.href = cfg.defaultURI
            }
            resolve(response)
          }).catch((error) => {
            this.showSpinner = false
            if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
              //  add error message here
              this.loginErrorMessage = error.response.data.errorMessage
            } else {
              this.loginErrorMessage = 'There was an unexpected error when trying to login.'
            }
            reject(error)
          })
        })
      },
      /**
       * Sets the authentication token in cookie
       * @param responseData
       */
      setData (response) {
        loginService.setAuthToken(response.securityToken, this.loginInfo.usrname)
        this.errorCode = response.errorCode
      },
      /**
       * Sets the username in cookie
       * @param username
       */
      saveUsername (username) {
        loginService.saveUsername(username)
      },
      redirectToForgotCredentials () {
        window.location.href = cfg.forgotCredentialsUrl
      },
      redirectToRegistration () {
        window.location.href = cfg.registrationUrl
      }
    }
  }
</script>

<style lang="scss">
  @import '../../node_modules/my-account-common-css/stylesheets/materialized.scss';
  @import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '../../node_modules/my-account-common-css/stylesheets/container.scss';
  @import '../../node_modules/element-ui/lib/theme-default/index.css';

  .login-container {
    padding: 0 20px;
    .section-separator {
      border-bottom: 1px solid red;
      margin-top: -8px;
      margin-bottom: 1px;
      width: 100%;
    }

    .login-section {
      margin-top: 15px;
    }

    .login-info-section {
      padding: 0 0 0 0;
    }

    .col-sm-12 {
      padding-left: 0px;
    }

    .col-md-6, .col-xs-12, .col-xs-6 {
      padding-left: 30px;
    }

    .login-desc-header {
      position: relative;
    }

    .login-desc {
      .login-desc-text {
        p {
          text-align: justify;
          margin-top: 10px;
          margin-left: 0px;
        }
      }
    }

    .login-end-page {
      margin-bottom: 100px;
    }

    .card-24 {
      float: left;
      border-top: 2px solid #eb2131;
      margin-bottom: 24px;
      width: 100%;
    }

    .register-now-btn {
      background-color: #D5D2CA;
      font-weight: 500;
    }

    .forgot-password-link {
      color: blue;
      margin-left: 15px;
      margin-top: 10px;
      margin-bottom: 10px;
      float: right;
      #label {
        top: 0;
      }
    }

    .create-account-link {
      color: blue;
      margin-left: 15px;
      margin-top: 10px;
      margin-bottom: 10px;
      float: left;
      #label {
        top: 0;
      }
    }

    .martop10 {
      margin-top: 10px;
    }

    .martop15 {
      margin-top: 15px;
    }

    .martop20 {
      margin-top: 20px;
    }

    .marleft10 {
      margin-left: 10px;
      display: block;
    }

    .marright10 {
      margin-right: 10px;
    }

    .materialized {
      .form-group {
        margin: 15px 0 10px;
      }
      .btn-primary {
        width: 45%;
        font-weight: 500;
      }
    }

    [class*="-desc-header"] {
      position: relative;

      .card-24 {
        width: 100%;
      }
    }
    .labelPointer {
      cursor: pointer;
    }
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {
    .login-container {
      margin: 0 10px 0 10px;

      .col-md-6, .col-xs-12, .col-xs-6 {
        padding: 0 10px 0 10px;
      }

      .error-message-section {
        padding: 0 15px 0 15px !important;
      }

      .login-section, .login-info-section {
        padding: 0 10px 0 10px;
      }

      .col-sm-12 {
        padding: 0 0 0 0;
      }

      .forgot-password-link {
        text-align: right;
      }
    }
    .controls-top, .controls-bottom {
      .info {
        display: inline;
      }
    }

    .container-24 .card-24 .card-img-container {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue